module.exports = __webpack_public_path__ + "images/sort-up-hover-acc078b1.svg";